/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const AFRAME = window.AFRAME;
const parseFn = function (prop) {
    if (typeof prop === "function") return prop;
    return null;
};
if (!AFRAME.components["grab-rotate"])
    AFRAME.registerComponent("grab-rotate", {
        schema: {
            lockCamera: { type: "boolean", default: false },
            setRotation: { parse: parseFn, default: null },
            setLockControls: { parse: parseFn, default: null }
        },
        update: function () {
            this.raycaster = document.querySelector("#mouse")
                ? document.querySelector("#mouse").components.raycaster
                : document.querySelector("#right-hand-raycaster").components
                      .raycaster;
            if (this.data.lockCamera) this.data.setLockControls(true);
        },

        tick: function () {
            if (this.raycaster && this.raycaster.intersectedEls) {
                const grabPlaneIndex = this.raycaster.intersectedEls
                    .map((x) => x.id === "grab-panel")
                    .indexOf(true);
                if (
                    this.raycaster.intersectedEls[grabPlaneIndex] &&
                    this.raycaster.intersections &&
                    this.raycaster.intersections[grabPlaneIndex]
                ) {
                    this.currentPoisition = this.raycaster.intersections[
                        grabPlaneIndex
                    ].point;
                    if (!this.previusPosition)
                        this.previusPosition = { ...this.currentPoisition };
                    if (
                        this.previusPosition.x !== this.currentPoisition.x ||
                        this.previusPosition.y !== this.currentPoisition.y
                    ) {
                        const diff = {
                            x: this.previusPosition.x - this.currentPoisition.x,
                            y: this.previusPosition.y - this.currentPoisition.y
                        };
                        const dominantAxis = Math.max(
                            Math.abs(diff.x),
                            Math.abs(diff.y)
                        );
                        if (
                            Math.abs(diff.x) < 5 &&
                            Math.abs(diff.y) < 5 &&
                            dominantAxis > 0.2
                        ) {
                            this.data.setRotation((old) => {
                                const rotation = old;
                                rotation.y = (rotation.y - diff.x * 25) % 360;
                                rotation.x = (rotation.x + diff.y * 25) % 360;

                                return rotation;
                            });

                            this.previusPosition = this.currentPoisition;
                        }
                    }
                } else {
                    this.el.removeAttribute("grab-rotate");
                }
            }
        },

        remove: function () {
            if (this.data.lockCamera) this.data.setLockControls(false);
        }
    });
